export default __webpack_public_path__ + "static/media/Poorly Grassed.39c969c0.png";